function digitsOnly(phone) {
  return String(phone || "").replace(/\D/g, "");
}

export function toWhatsAppE164(phone) {
  let d = digitsOnly(phone);
  if (!d) return "";
  if (d.startsWith("00")) d = d.slice(2);
  if (d.startsWith("91") && d.length === 12) return d;
  if (d.length === 11 && /^0[6-9]\d{9}$/.test(d)) return `91${d.slice(1)}`;
  if (d.length === 10 && /^[6-9]\d{9}$/.test(d)) return `91${d}`;
  return d;
}

export function looksLikeMobile(phone) {
  const e = toWhatsAppE164(phone);
  if (/^91[6-9]\d{9}$/.test(e)) return true;
  if (e.startsWith("91")) return false;
  return e.length >= 11 && e.length <= 15;
}

export function coerceWhatsAppFlag(value) {
  if (value === true || value === 1 || value === "1") return true;
  if (value && typeof value === "object" && Array.isArray(value.data)) {
    return Number(value.data[0]) !== 0;
  }
  if (value === false || value === 0 || value === "0") return false;
  return null;
}

/**
 * Same rule as goldpe.tech API / CRM:
 * No WA only when there is no mobile, or a saved WhatsApp check failed.
 * +91 / 10-digit / 91xxxxxxxxxx are the same number.
 * Default has_whatsapp=0 is not a failed check.
 */
export function employeeHasWhatsApp(emp) {
  if (!emp) return false;
  if (!looksLikeMobile(emp.phone)) return false;
  const checked = coerceWhatsAppFlag(emp.whatsapp_checked);
  const f = coerceWhatsAppFlag(emp.hasWhatsapp ?? emp.has_whatsapp);
  if (checked === true && f === false) return false;
  return true;
}
